import { Button, Spinner } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import useTranslate from 'hooks/useTranslate';
import { useEffect, useState } from 'react';
import { logPurchaseCompleted, usePurchaseStatusQuery } from 'services';
import './styles.scss';

const PaymentSuccess = () => {
	const navigate = useNavigate();
	const { translate } = useTranslate();
	const location = useLocation();
	const searchParams = new URLSearchParams(location.search);
	const purchase_id = searchParams.get('purchase_id');
	const [timeOver, setTimeOver] = useState<boolean>(false);

	const [timer, setTimer] = useState<any>(null);
	const [timeOutTimer, setTimeOutTimer] = useState<any>(null);

	useEffect(() => {
		logPurchaseCompleted(purchase_id);
	}, []);

	const handlePrint = () => {
		const section = document.querySelector('.payment-message-details');
		if (section) {
			const printWindow = window.open('', '_blank');
			if (printWindow) {
				printWindow.document.write(`
				<html>
				  <head>
					<title>Invoice</title>
					<style>
					  body {
						font-family: Arial, sans-serif;
						margin: 0;
						padding: 1rem;
						background-color: #f9f9f9;
						text-align: center;
						border: 2px solid 0000;
					  }
					</style>
				  </head>
				  <body>
					${section.outerHTML}
				  </body>
				</html>
			  `);
				printWindow.document.close();
				printWindow.focus();
				printWindow.print();
				printWindow.close();
			}
		}
	};

	const onCloseHandler = () => {
		const redirectURL = sessionStorage.getItem('redirectURL');
		redirectURL
			? (navigate(redirectURL), sessionStorage.removeItem('redirectURL'))
			: navigate('/company/subscriptions');
	};
	const { data: paymentDetails = {}, refetch } = usePurchaseStatusQuery(purchase_id);

	useEffect(() => {
		setTimeOutTimer(
			setTimeout(() => {
				setTimeOver(true);
			}, 90000),
		);

		setTimer(
			setInterval(() => {
				refetch();
			}, 15000),
		);

		return () => {
			clearTimeout(timeOutTimer);
			clearInterval(timer);
		};
	}, []);

	useEffect(() => {
		if (paymentDetails?.success === true) {
			if (paymentDetails?.data?.status === 'succeeded') {
				clearTimeout(timeOutTimer);
				clearInterval(timer);
			} else {
				navigate('/payment-failed');
			}
		}
	}, [paymentDetails]);

	return (
		<>
			{paymentDetails?.data?.status === 'succeeded' ? (
				<section className="payment-message d-flex align-items-center justify-content-center">
					<div className="payment-message-card bg-white w-100">
						<h2 className="fw-bold text-center mb-4">{translate('Common.paymentSuccessfull')}</h2>
						<div className="payment-message-details d-flex flex-column gap-2">
							{paymentDetails?.data?.transaction_id && (
								<div className="d-flex align-items-center justify-content-between gap-5">
									<h5 className="mb-0 fw-semibold">{translate('Common.transactionId')}</h5>
									<p className="mb-0">{paymentDetails?.data.transaction_id}</p>
								</div>
							)}
							{paymentDetails?.data?.price_paid && (
								<div className="d-flex align-items-center justify-content-between gap-5 mt-3">
									<h5 className="mb-0 fw-semibold">{translate('Common.amountPaid')}</h5>
									<p className="mb-0 fw-semibold">
										{paymentDetails?.data.price_paid}{' '}
										{paymentDetails?.data?.currency
											? paymentDetails?.data.currency.toUpperCase()
											: ''}
									</p>
								</div>
							)}
						</div>
						<div className="text-center action-section">
							<Button
								className="payment-message-btn filled border-0 text-white rounded-pill"
								onClick={() => handlePrint()}
							>
								{translate('Common.print')}
							</Button>
							<Button
								className="payment-message-btn border rounded-pill"
								onClick={() => onCloseHandler()}
							>
								{translate('Common.close')}
							</Button>
						</div>
					</div>
				</section>
			) : (
				<section className="payment-message d-flex align-items-center justify-content-center">
					<div className="payment-message-card bg-white w-100">
						{timeOver ? (
							<>
								<h2 className="fw-bold text-center mb-4">{translate('Common.PaymentTimeout')}</h2>
								<div className="text-center action-section">
									<Button
										className="payment-message-btn border rounded-pill"
										onClick={() => onCloseHandler()}
									>
										{translate('Common.close')}
									</Button>
								</div>
							</>
						) : (
							<>
								<div className="payment-message-card-icon mb-4 text-center">
									<Spinner variant="primary" animation="border" />
								</div>
								<h2 className="fw-bold text-center mb-4">
									{translate('Common.paymentProcessing')}
								</h2>
							</>
						)}
					</div>
				</section>
			)}
		</>
	);
};

export default PaymentSuccess;
